export const submissionsConfig = {
  postingRate: 3,
  expediteThresholdDays: 7, // Minimum days into the future a post must be scheduled to show expedite nudges
}
